<template>
  <a-drawer
    v-model:open="model"
    class="drawer-facade"
    root-class-name="drawer-facade-root"
    :destroy-on-close="true"
    placement="right"
    :width="500"
    @close="(event) => $emit('close', event)"
  >
    <template v-if="$slots.closeIcon" #closeIcon>
      <slot name="closeIcon"></slot>
    </template>
    <template #default>
      <slot></slot>
    </template>
  </a-drawer>
</template>

<script setup>
  import { defineModel } from 'vue';
  
  const model = defineModel();

  defineEmits(['close']);
</script>

<style lang="scss">
  .drawer-facade-root {
    .ant-drawer-mask {
      background: transparent;
    }
  }
</style>